module.exports = __webpack_public_path__ + "img/bg.29c04ff7.png";